module.exports = "/video-roulette/img/orange-ball.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/video-roulette/img/orange-ball.png
// module id = 2048
// module chunks = 9